"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-15f805f3"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = {
    key: 0,
    class: "2xl:container mx-auto px-4 py-7 my-3 bg-white rounded-2xl"
};
const _hoisted_2 = { class: "text-center text-[34px] mb-3 font-bold" };
const _hoisted_3 = { class: "text-center mb-5" };
const _hoisted_4 = { class: "ql-snow" };
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "font-bold text-2xl" };
const _hoisted_8 = { class: "pl-0" };
const _hoisted_9 = ["href"];
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const toastStore_1 = require("../../stores/toast/toastStore");
const newsStore_1 = require("../../stores/news/newsStore");
const newsFileStore_1 = require("../../stores/newsFiles/newsFileStore");
const i18n_1 = require("../../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'NewsArticle',
    setup(__props) {
        const newsStore = (0, newsStore_1.useNewsStore)();
        const newsFileStore = (0, newsFileStore_1.useNewsFileStore)();
        const route = (0, vue_router_1.useRoute)();
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const newsArticle = (0, vue_3.computed)(() => newsStore.article);
        const newsFiles = (0, vue_3.computed)(() => newsFileStore.newsFiles);
        (0, vue_3.onBeforeMount)(async () => {
            newsStore.reset();
            try {
                await newsStore.getArticle(router, route.params.id);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
            try {
                await newsFileStore.getNewsFiles(router, { pagination: false, news: route.params.id });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(newsArticle))
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(newsArticle).title), 1),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(newsArticle).createdDatetime), 1),
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createElementVNode)("article", {
                            class: "ql-editor",
                            innerHTML: (0, vue_2.unref)(newsArticle).body
                        }, null, 8, _hoisted_5)
                    ]),
                    ((0, vue_2.unref)(newsFiles).length > 0)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, [
                            (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("news_related_files", "News related files", "news_article")), 1),
                            (0, vue_2.createElementVNode)("ul", _hoisted_8, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(newsFiles), (newsFile) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                                        key: newsFile.id,
                                        class: "my-2"
                                    }, [
                                        (0, vue_2.createElementVNode)("a", {
                                            target: "_blank",
                                            href: newsFile.contentUrl
                                        }, (0, vue_2.toDisplayString)(newsFile.originalFileName), 9, _hoisted_9)
                                    ]));
                                }), 128))
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
